import { useUnit } from 'effector-react';
import { useEffect, useRef } from 'react';
import { BetMenu } from 'widgets/bet-menu';
import { calculatorBetModel } from 'widgets/calculator-bet';
import { GameField, gameFieldModel } from 'widgets/game-field';
import { Header } from 'widgets/header';
import { InteractiveElement } from 'widgets/interactive-element';
import { SidebarButton } from 'widgets/sidebar';
import { IS_STEPBALL } from 'shared/config';
import { isDesktop } from 'shared/lib';
import ChezachiniLogo from 'shared/ui/assets/icons/chezachini-logo.svg?react';
import StepballLogo from 'shared/ui/assets/icons/stepball-logo.svg?react';
import { GAME_PAGE_MAIN_ID } from '../../config';
import { useScaleLogo } from '../../lib';
import cls from './game-page.module.scss';

const GameLogo = IS_STEPBALL ? StepballLogo : ChezachiniLogo;

export const GamePage = () => {
	const [openCalculatorBet, unlockGameField] = useUnit([
		calculatorBetModel.switcher.enable,
		gameFieldModel.fieldDisabledToggler.disable,
	]);

	const logoRef = useScaleLogo();
	const gamePageRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const handleResize = () => {
			if (gamePageRef.current === null) return;
			const width = document.documentElement.clientWidth;
			const height = document.documentElement.clientHeight;

			if (isDesktop(width, height)) {
				const horizontalOffset = 1;
				const verticalOffset = 0.9;

				const scaleX = (width / gamePageRef.current.clientWidth) * horizontalOffset;
				const scaleY = (height / gamePageRef.current.clientHeight) * verticalOffset;

				gamePageRef.current.style.scale = `${Math.min(scaleX, scaleY)}`;

				return;
			}

			gamePageRef.current.style.scale = width > 600 && height <= 700 ? `${height / 700}` : '1';
		};

		handleResize();

		window.addEventListener('resize', handleResize);

		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	return (
		<>
			<div
				ref={logoRef}
				className={cls.gamePageLogoWrapper}
			>
				<GameLogo className={cls.gamePageLogo} />
			</div>
			<div
				ref={gamePageRef}
				className={cls.gamePageWrapper}
				id='game-page-wrapper'
			>
				<Header
					contentSlot={<InteractiveElement onMessageClose={unlockGameField} />}
					actionSlot={<SidebarButton />}
				/>
				<main
					className={cls.gamePageMain}
					id={GAME_PAGE_MAIN_ID}
				>
					<div className={cls.gamePageContent}>
						<GameField className={cls.gamePageGameField} />
						<BetMenu
							className={cls.gamePageBetMenu}
							onReadonlyClick={openCalculatorBet}
						/>
					</div>
				</main>
			</div>
		</>
	);
};
